var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4F9E7D",
    d: "M15.957 8A7.958 7.958 0 1 1 .04 8a7.958 7.958 0 0 1 15.916 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.896 7.672V5.715H4.242V4h7.417v1.74H9.005v1.932H6.896Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.102 7.89c0-.652 2.133-1.184 4.787-1.184s4.788.532 4.788 1.184c0 .652-2.134 1.184-4.788 1.184-2.654 0-4.787-.532-4.787-1.184Zm9.179 0c-.174-.242-1.612-.99-4.39-.99-2.779 0-4.218.724-4.391.99.173.241 1.612.604 4.39.604 2.803 0 4.217-.363 4.391-.604Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.004 8.276V6.923c-.348-.024-.72-.048-1.092-.048-.347 0-.67 0-.992.024v1.353c.298 0 .645.024.992.024.372.024.744.024 1.092 0Zm-1.117.797c-.348 0-.67 0-.992-.024v3.6h2.083V9.025c-.347.024-.72.048-1.091.048Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.3e74025f999b609df5aad5f70278697a.svg";
export { ForwardRef as ReactComponent };